import Vue from 'vue'

const vm = new Vue()

// 获取用户绑定的燃气号列表
export function getUserGasList (params) {
  return vm.$http.get('i/api/getUserGasList/' + params.userId)
}

// 解绑燃气号
export function unbindUserGas (params) {
  return vm.$http.get('i/api/unbindUserGas/' + params.id)
}

// 发送并验证验证码
export function getVerificationCode (params) {
  return vm.$http.post('c/api/getVerificationCode', params)
}

// 校验燃气户号(用户编号)
export function checkUserGas (params) {
  return vm.$http.post('i/api/checkUserGas', params)
}

// 确认绑定燃气号
export function newConfirmBindUserGas (params) {
  return vm.$http.post('i/api/newConfirmBindUserGas', params)
}

// 提交地址咨询单信息
export function addConsulting (params) {
  return vm.$http.post('i/api/consulting/addConsulting', params)
}
